import { useState } from "react";
import ClientProfileInfoTab from "./tabs/ClientProfileInfoTab";
import ClientProfileReservationTab from "./tabs/ClientProfileReservationTab";
import ClientProfileOrderTab from "./tabs/ClientProfileOrderTab";
import { ArrowLeftBlackIcon, OrderBlackIcon, ReservationBlackIcon, UserBlackIcon } from "../../../assets/icons";
import { useAuth } from "../../../auth/AuthContext";

type ClientProfileTab = "profile" | "reservations" | "orders";

const ClientProfilePage: React.FC = () => {

    const [selectedTab, setSelectedTab] = useState<ClientProfileTab>("profile");

    const { logout } = useAuth();

    return (
        <>
            <section className="client-profile-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="user-profile-wrapper">

                        <div className="user-profile-header-div">
                            <div className="div-block-50" onClick={() => window.history.back()}>
                                <img src={ArrowLeftBlackIcon} loading="lazy" alt="" className="icon-size-20" />
                                <div>Nazad</div>
                            </div>
                            <div className="button-primary red-bg" onClick={() => { logout();}}>
                                <div>Odjavi se</div>
                            </div>
                        </div>


                        <div className="tab-navigation-list-div">

                            <div className={`tab-navigation-div ${selectedTab === "profile" ? "selected" : ""}`} onClick={() => setSelectedTab("profile")}>
                                <img src={UserBlackIcon} loading="lazy" alt="" className="icon-size-16" />
                                <div>Profil</div>
                            </div>

                            <div className={`tab-navigation-div ${selectedTab === "reservations" ? "selected" : ""}`} onClick={() => setSelectedTab("reservations")}>
                                <img src={ReservationBlackIcon} loading="lazy" alt="" className="icon-size-16" />
                                <div>Rezervacije</div>
                            </div>

                            <div className={`tab-navigation-div ${selectedTab === "orders" ? "selected" : ""}`} onClick={() => setSelectedTab("orders")}>
                                <img src={OrderBlackIcon} loading="lazy" alt="" className="icon-size-16" />
                                <div>Porudžbine</div>
                            </div>

                        </div>

                        {selectedTab === "profile" &&
                            <ClientProfileInfoTab />
                        }

                        {selectedTab === "reservations" &&
                            <ClientProfileReservationTab />
                        }

                        {selectedTab === "orders" &&
                            <ClientProfileOrderTab />
                        }


                    </div>
                </div>
            </section>
        </>
    );

};

export default ClientProfilePage;